import styled from 'styled-components'
import {Dialog} from '@mui/material'
import {FilterContainer} from '../../../subjects/Subject.style'

export {FilterContainer}

export const FilterHead = styled.div`
  position: relative;
  min-width: 150px;
  justify-content: end;

  div {
    cursor: pointer;
    display: flex;
    align-items: center;
  }
`

export const DialogMUI = styled(Dialog)`
  .MuiPaper-root {
    width: 100%;
    padding: 12px;
    vertical-align: top;
    margin-top: 120px;
  }
` 